/* eslint-disable import/no-duplicates */
/* eslint-disable react/destructuring-assignment */

import { ReactNode } from 'react';
import * as React from 'react';
import Helmet from 'react-helmet';

import styles from './pageTitle.module.scss';

interface PageTitleOwnProps {
  displayTitle: string;
  pageTitle?: string;
  subtitles?: ReactNode[];
}

export class PageTitle extends React.Component<PageTitleOwnProps> {
  private renderSubtitles() {
    return (
      <div className={styles.subtitles}>
        {this.props.subtitles.map((s, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className={`${styles.subtitle}${index > 0 ? ` ${styles.withSeparator}` : ''}`} key={index}>
            {s}
          </div>
        ))}
      </div>
    );
  }

  public render() {
    return (
      <div className={styles.pageTitle}>
        <Helmet>
          <title>{this.props.pageTitle || this.props.displayTitle}</title>
        </Helmet>
        <div className={styles.title}>
          <span className={styles.name}>{this.props.displayTitle}</span>
          <div className={styles.titleChildren}>{this.props.children}</div>
        </div>
        {this.props.subtitles && this.renderSubtitles()}
      </div>
    );
  }
}
